export enum ItemCardType {
  NORMAL = 1,
  EXPANDED,
  LITE
}
